import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

export const submitPollAnswer = async (pollId: string, selectedOption: string, email: string) => {
  try {
    const response = await axios.post(`${HOSTAPI}/poll/${pollId}/respond`, 
    {
      selectedOption,
      email
    }, 
    {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response ? error.response.status : 500,
      data: error.response ? error.response.data : 'Server Error',
    };
  }
};

export default submitPollAnswer;
